import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Skeleton, { SKELETON_WIDTHS } from '@buyside/components/presentation/Skeleton/skeleton';

import styles from './mediaIndexPageStyles.scss';

const MediaIndexItemLoading: React.FC = () => (
  <div className={styles.mediaIndexItem}>
    <div className={styles.thumbnail}>
      <FontAwesomeIcon className={styles.skeleton} icon={faSpinner} spin />
    </div>
    <p>
      <Skeleton width={SKELETON_WIDTHS.FULL} />
      <Skeleton width={SKELETON_WIDTHS.ONE_THIRD} />
    </p>
    <p>
      <Skeleton width={SKELETON_WIDTHS.FULL} />
      <Skeleton width={SKELETON_WIDTHS.FULL} />
      <Skeleton width={SKELETON_WIDTHS.TWO_THIRD} />
    </p>
  </div>
);

export default MediaIndexItemLoading;
